import React, { Component } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide,
  LinearProgress,
} from "@material-ui/core";
import {
  IconButton,
  Link as MaterialLink,
  CircularProgress,
  TextField,
  InputBase,
} from "@material-ui/core";

import { FormErrors } from "../Login/FormErrors";
import CloseIcon from "@material-ui/icons/Close";
import Box from "@material-ui/core/Box";
import { formatDateToLocalFormat, downloadMedia } from "__helpers/util";

import { userService } from "_services/user.service";
import DateFnsUtils from "@date-io/date-fns";
import { apiPath } from "api";
import {
  generalAuthTokenHeader,
  generalMimeAuthTokenHeader,
} from "__helpers/auth-header";
import fileExtension from "file-extension";
import enMsg from "__helpers/locale/en/en";
import { USER_INFO } from "__helpers/constants";
import { Scrollbars } from "react-custom-scrollbars";

import {
  REFERRAL_TYPE,
  ALLOWED_PROFILE_IMAGE_SIZE,
  ALLOWED_FACESHEET_EXTENTION,
  MAX_INPUT_LENGTH_LONG,
} from "__helpers/constants";
import { files } from "jszip";

class Comment extends Component {
  inputOpenFileRef = React.createRef(null);

  constructor(props) {
    super(props);
    this.dateUtility = new DateFnsUtils();
    let userInfo = JSON.parse(localStorage.getItem(USER_INFO));
    let initialSenderId = null;
    let filteredPrelimnComment =
      this.props.prelimComment && this.props.prelimComment.length
        ? this.props.prelimComment.filter((comments) => {
            if (initialSenderId != comments.commentedBy) {
              initialSenderId = comments.commentedBy;
              return comments;
            }
          })
        : [];
    this.state = {
      comment: "",
      formErrors: {
        comment: "",
        file: "",
      },
      fileName: "",
      file: "",
      fileBlob: "",
      fileValid: false,
      commentValid: false,
      commentsThread: [],
      commentLoading: false,
      fileData: null,
      referralId: this.props.referralId ? this.props.referralId : "",
      prelimComment: filteredPrelimnComment,
      loginproviderId: userInfo ? userInfo.provider.id : "",
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount = () => {
    this.fetchComments(this.props.referralId);
  };
  componentWillReceiveProps(nextProps) {
    if (nextProps.referralId != this.state.referralId) {
      this.fetchComments(nextProps.referralId);
    }
  }
  fetchComments = (referralId) => {
    this.setState({
      commentsThread: [],
      commentLoading: true,
    });
    const response = fetch(
      apiPath.getCommentToDP +
        "?patientId=" +
        this.props.patientId +
        "&refferalId=" +
        referralId +
        "&sort=createdDateTime,Desc",
      {
        method: "GET",
        headers: generalAuthTokenHeader(),
      },
    )
      .then((response) => {
        console.log(response);
        if (response.status === 400) {
        } else if (response.ok) {
        } else {
        }
        return response.json();
      })
      .then((data) => {
        console.log(data);
        if (data.length) {
          this.setState({
            commentsThread: data,
          });
        }
        this.setState({
          commentLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          commentLoading: false,
        });
      });
  };
  validateField = (fieldName, fieldValue) => {
    let fieldValidationErrors = this.state.formErrors;
    let commentValid = this.state.commentValid;
    switch (fieldName) {
      case "comment":
        let commentErr = "";
        if (fieldValue.trim().length == 0) {
          commentValid = false;
          commentErr = "Comment is required";
        } else if (fieldValue.trim().length > MAX_INPUT_LENGTH_LONG) {
          commentValid = false;
          commentErr = "Comment length cannot exceed 255 characters";
        } else {
          commentValid = true;
          commentErr = "";
        }
        fieldValidationErrors.comment = commentErr;
        break;
      default:
        break;
    }
    this.setState(
      {
        formErrors: fieldValidationErrors,
        commentValid: commentValid,
      },
      this.validateForm,
    );
  };
  validateForm() {
    return this.state.commentValid || this.state.fileValid;
  }
  onFileBrowse = (event) => {
    this.inputOpenFileRef.current.click();
  };
  async handleSubmit(event) {
    event.preventDefault();
    let dataLock = {
      base64Data: this.state.file,
      description: this.state.comment,
      fileName: this.state.fileName,
      receiverId: this.props.receiverId ? this.props.receiverId : "",
      refferalId: this.props.referralId ? this.props.referralId : "",
      patientId: this.props.patientId ? this.props.patientId : "",
    };
    const data = new FormData();
    if (this.state.fileData) {
      data.append("base64Data", this.state.fileData);
      data.append("fileName", this.state.fileName);
    }
    data.append("description", this.state.comment);
    data.append(
      "receiverId",
      this.props.receiverId ? this.props.receiverId : "",
    );
    data.append(
      "refferalId",
      this.props.referralId ? this.props.referralId : "",
    );
    data.append("patientId", this.props.patientId ? this.props.patientId : "");

    this.setState({ loading: true });
    let showNotification = {};
    let modalCloseStatus = 1;
    const response = await fetch(apiPath.postCommentByDP, {
      method: "POST",
      headers: generalMimeAuthTokenHeader(),
      body: data,
      data: data,
    })
      .then((response) => {
        if (response.status === 400) {
          showNotification = {
            title: "Comment",
            message: enMsg.badResponseFromServer,
            type: "danger",
          };
        } else if (response.ok) {
        } else {
          showNotification = {
            title: "Comment",
            message: enMsg.badResponseFromServer,
            type: "danger",
          };
        }
        return response.json();
      })
      .then((data) => {
        if (data.title) {
          showNotification = {
            title: "Comment",
            message: data.title,
            type: "dangerLong",
          };
        }
        if (data.id) {
          this.fetchComments(this.props.referralId);
          this.setState({
            fileData: null,
            comment: "",
            fileName: "",
            file: "",
            commentValid: false,
            fileValid: false,
          });
          showNotification = {
            title: "Comment",
            message: "Message has been sent.",
            type: "success",
          };
        }
      })
      .catch((error) => {
        showNotification = {
          title: "Comment",
          message: enMsg.clientSideError,
          type: "danger",
        };
      });
    userService.showNotification(showNotification);
    this.setState({ loading: false });
  }
  handleSelectedFile = (event) => {
    event.preventDefault();
    let file = event.target.files[0];
    if (typeof file === "undefined" && this.state.fileName == "") {
      this.setState({
        commentValid: false,
        fileValid: false,
      });
      return;
    }
    let fieldValidationErrors = this.state.formErrors;
    let error = "";
    let fileValid = false;
    if (typeof file == "object" && file.size > ALLOWED_PROFILE_IMAGE_SIZE) {
      error = enMsg.allowedFaceSheetSize;
    } else if (
      typeof file == "object" &&
      !ALLOWED_FACESHEET_EXTENTION.includes(file.type)
    ) {
      error = enMsg.allowedFaceSheetType;
    } else {
      fileValid = true;
    }

    if (typeof file !== undefined && fileValid) {
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        let result = fileReader.result;
        this.setState({
          fileName: file.name,
          file: result,
        });
        this.fileBlob = file;
        this.filename = new Date().getTime() + "." + fileExtension(file.name);
      });
      if (file) {
        this.setState({
          fileData: file,
        });
        fileReader.readAsDataURL(file);
      }
    }
    if (!fileValid) {
      this.setState({
        fileName: "",
      });
    }

    fieldValidationErrors.file = fileValid ? "" : error;
    this.setState(
      {
        fileValid: fileValid,
        formErrors: fieldValidationErrors,
      },
      this.validateForm,
    );
  };
  downloadFile = async (fileName, fileUrl, toId) => {
    console.log(toId);
    let showNotification = {};
    try {
      let showNotification = {
        title: "Facesheet",
        message: "Please wait, Downloading files",
        type: "info",
      };
      userService.showNotification(showNotification);
      let urlArr = fileUrl.split("/");
      let urlArrEndPoint =
        urlArr[urlArr.length - 2] + "/" + urlArr[urlArr.length - 1];
      let dataUses = "";
      if (toId == this.state.loginproviderId) {
        dataUses =
          "?patientId=" +
          this.props.patientId +
          "&refferalId=" +
          this.props.referralId +
          "&key=" +
          urlArrEndPoint;
      } else {
        dataUses = "?key=" + urlArrEndPoint;
      }
      let sheetData = await userService.fetchCommentSheetsData(
        apiPath.downloadCommentFile + dataUses,
        fileName,
      );
    } catch (error) {
      showNotification = {
        title: "Facesheet",
        message: "No facesheet available.",
        type: "danger",
      };
      userService.showNotification(showNotification);
    }
    this.setState({
      loading: false,
    });
    return false;
  };
  handleChangeInput = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    this.setState(
      {
        [name]: value,
      },
      () => {
        this.validateField(name, value);
      },
    );
  };
  render() {
    const tableHeaderStyle = {
      backgroundColor: "#f5f5f5",
      padding: "14px 16px",
      textAlign: "left",
      fontWeight: "600",
      color: "#555",
      fontSize: "13px",
      borderBottom: "2px solid #e8e8e8",
    };
    const tableCellStyle = {
      padding: "14px 16px",
      borderBottom: "1px solid #f0f0f0",
      fontSize: "13px",
      color: "#333",
      verticalAlign: "middle",
    };

    return (
      <form onSubmit={this.handleSubmit} noValidate style={{ width: "100%", maxWidth: "100%", overflow: "hidden" }}>
        <Box width={1} display="flex" flexDirection="column" style={{ maxWidth: "100%", overflow: "hidden" }}>
          {/* Comments Table */}
          <Box
            width={1}
            className="loader-width-position"
            mb={2}
            style={{
              borderRadius: "8px",
              border: "1px solid #e8e8e8",
              backgroundColor: "#F1F1F1",
            }}
          >
            <Scrollbars
              autoHide={false}
              universal={true}
              autoHeight={true}
              autoHeightMin={0}
              autoHeightMax={250}
              className="commentTableScroll"
              renderView={props => (
                <div {...props} style={{ ...props.style, marginRight: 0, marginBottom: 0, overflowX: "hidden", paddingRight: "8px" }} />
              )}
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  backgroundColor: "#fff",
                  tableLayout: "fixed",
                }}
              >
                <thead>
                  <tr>
                    <th style={{ ...tableHeaderStyle, width: "20%" }}>Name</th>
                    <th style={{ ...tableHeaderStyle, width: "40%" }}>
                      Message
                    </th>
                    <th style={{ ...tableHeaderStyle, width: "15%" }}>
                      Attachment
                    </th>
                    <th style={{ ...tableHeaderStyle, width: "25%" }}>
                      Timestamp
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.commentLoading ? (
                    <tr>
                      <td colSpan="4" style={{ padding: "16px" }}>
                        <LinearProgress color="primary" />
                      </td>
                    </tr>
                  ) : null}

                  {this.state.commentsThread.length
                    ? this.state.commentsThread.map((comment, key) => (
                        <tr key={key}>
                          <td style={tableCellStyle}>
                            {comment.fromUser.firstName +
                              " " +
                              (comment.fromUser.middleName !== null
                                ? comment.fromUser.middleName
                                : "") +
                              " " +
                              comment.fromUser.lastName}
                          </td>
                          <td style={tableCellStyle}>
                            <div className="commentdescription">
                              {comment.description}
                            </div>
                          </td>
                          <td style={tableCellStyle}>
                            {comment.fileName ? (
                              <i
                                className="fa fa-download pointer"
                                aria-hidden="true"
                                style={{ color: "#01A7A6", cursor: "pointer" }}
                                onClick={() =>
                                  this.downloadFile(
                                    comment.fileName,
                                    comment.uploadFileUrl,
                                    comment.toId,
                                  )
                                }
                              ></i>
                            ) : (
                              <span style={{ color: "#999" }}>
                                No Attachment
                              </span>
                            )}
                          </td>
                          <td style={tableCellStyle}>
                            {comment.formattedCreatedDateTime}
                          </td>
                        </tr>
                      ))
                    : null}

                  {this.state.prelimComment && this.state.prelimComment.length
                    ? this.state.prelimComment.map((comment, key) => (
                        <tr key={`prelim_${key}`}>
                          <td style={tableCellStyle}>
                            {comment.createdUser &&
                            comment.createdUser.firstName
                              ? comment.createdUser.firstName +
                                " " +
                                comment.createdUser.lastName
                              : "N/A"}
                          </td>
                          <td style={tableCellStyle}>
                            <div className="commentdescription">
                              {comment.comment}
                            </div>
                          </td>
                          <td style={tableCellStyle}>
                            {comment.fileName ? (
                              <i
                                className="fa fa-download pointer"
                                aria-hidden="true"
                                style={{ color: "#01A7A6", cursor: "pointer" }}
                                onClick={() =>
                                  this.downloadFile(
                                    comment.fileName,
                                    comment.uploadFileUrl,
                                    comment.toId,
                                  )
                                }
                              ></i>
                            ) : (
                              <span style={{ color: "#999" }}>
                                No Attachment
                              </span>
                            )}
                          </td>
                          <td style={tableCellStyle}>
                            {comment.formattedCreatedDateTime
                              ? comment.formattedCreatedDateTime
                              : "N/A"}
                          </td>
                        </tr>
                      ))
                    : null}

                  {!this.state.commentsThread.length &&
                  !this.state.prelimComment.length &&
                  !this.state.commentLoading ? (
                    <tr>
                      <td
                        colSpan="4"
                        style={{
                          ...tableCellStyle,
                          textAlign: "center",
                          color: "#999",
                        }}
                      >
                        No Comments!
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
            </Scrollbars>
          </Box>

          {/* Input Section */}
          <Box
            width={1}
            display="flex"
            alignItems="center"
            style={{
              border: "1px solid #D8D8D8",
              borderRadius: "30px",
              padding: "6px 8px 6px 20px",
              backgroundColor: "#F1F1F1",
              boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
              maxWidth: "100%",
              boxSizing: "border-box",
            }}
          >
            <input
              type="file"
              id="file"
              ref={this.inputOpenFileRef}
              onChange={(event) => this.handleSelectedFile(event)}
              accept="image/x-png, image/jpg, image/jpeg, application/pdf"
              style={{ display: "none" }}
            />

            <InputBase
              placeholder="Write your message here...."
              name="comment"
              value={this.state.comment}
              onChange={this.handleChangeInput}
              style={{ flex: 1, fontSize: "14px", color: "#000", minWidth: 0 }}
            />

            {this.state.fileName && (
              <span
                style={{
                  fontSize: "12px",
                  color: "#666",
                  marginRight: "8px",
                  maxWidth: "100px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {this.state.fileName}
              </span>
            )}

            {/* Attachment Icon - Paperclip SVG */}
            <IconButton
              size="small"
              className="g-paperclip-icon"
              onClick={(event) => this.onFileBrowse(event)}
              style={{
                padding: "8px",
              }}
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.13846 1.53816C9.61879 1.05221 10.1901 0.666168 10.8197 0.402208C11.4492 0.138247 12.1246 0.00156659 12.807 1.33881e-05C13.4894 -0.00153981 14.1654 0.132065 14.7961 0.393157C15.4268 0.654248 15.9999 1.03768 16.4825 1.52144C16.965 2.0052 17.3474 2.57976 17.6079 3.21212C17.8683 3.84448 18.0015 4.52219 18 5.20632C17.9984 5.89046 17.8621 6.56756 17.5988 7.19872C17.3355 7.82989 16.9505 8.4027 16.4658 8.88426L8.25513 17.116C7.66309 17.6895 6.87 18.007 6.04673 17.9999C5.22347 17.9928 4.43593 17.6617 3.85382 17.078C3.2717 16.4943 2.9416 15.7047 2.93464 14.8794C2.92769 14.054 3.24443 13.2589 3.81663 12.6654L11.1093 5.35409C11.2304 5.23685 11.3925 5.17198 11.5608 5.17345C11.7291 5.17491 11.8902 5.2426 12.0092 5.36193C12.1282 5.48126 12.1957 5.64268 12.1972 5.81143C12.1986 5.98019 12.1339 6.14276 12.017 6.26415L4.72436 13.5755C4.3896 13.9269 4.20529 14.3957 4.21086 14.8815C4.21642 15.3674 4.41142 15.8318 4.75413 16.1754C5.09684 16.519 5.56006 16.7145 6.0447 16.7201C6.52934 16.7257 6.99691 16.5409 7.3474 16.2053L15.558 7.97356C15.9239 7.6116 16.2147 7.18066 16.4137 6.70556C16.6128 6.23045 16.7161 5.72057 16.7178 5.20527C16.7195 4.68996 16.6195 4.17941 16.4235 3.70302C16.2276 3.22662 15.9396 2.79378 15.5761 2.42943C15.2127 2.06507 14.7809 1.77639 14.3057 1.58001C13.8305 1.38363 13.3213 1.28343 12.8073 1.28518C12.2933 1.28693 11.7847 1.39059 11.3109 1.59019C10.837 1.78979 10.4072 2.0814 10.0462 2.44822L1.10371 11.4136C1.04449 11.4751 0.973656 11.5241 0.895335 11.5579C0.817013 11.5916 0.732776 11.6093 0.647537 11.6101C0.562298 11.6108 0.477765 11.5945 0.398871 11.5622C0.319976 11.5298 0.248301 11.482 0.188025 11.4216C0.12775 11.3612 0.0800827 11.2893 0.0478044 11.2102C0.0155262 11.1311 -0.000716464 11.0464 2.42382e-05 10.9609C0.00076494 10.8755 0.0184742 10.791 0.0521186 10.7125C0.085763 10.634 0.134669 10.5629 0.195982 10.5036L9.13846 1.53816Z"
                  fill="black"
                />
              </svg>
            </IconButton>

            {/* Send Icon - Arrow SVG */}
            <IconButton
              type="submit"
              size="small"
              disabled={!this.validateForm() || this.state.loading}
              style={{
                backgroundColor: "#01A7A6",
                marginLeft: "4px",
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                flexShrink: 0,
                transition: "background-color 0.2s ease",
              }}
              className="g-send-arrow-btn"
            >
              {this.state.loading ? (
                <CircularProgress size={18} style={{ color: "#fff" }} />
              ) : (
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.30079 0.0548763C0.790611 0.179207 0.387611 0.517899 0.151813 1.01522C0.0317706 1.27245 0.0189089 1.34533 0.0189089 1.68831C0.0189089 2.04415 0.0875046 2.3314 0.880643 5.49538C1.35653 7.37747 1.75095 8.92945 1.76381 8.93803C1.78525 8.95946 3.38439 9.1138 8.96637 9.62398C10.2097 9.73974 11.2257 9.84263 11.2257 9.8555C11.2257 9.86836 10.2097 9.97125 8.96637 10.087C3.38439 10.5972 1.78525 10.7515 1.76381 10.773C1.72094 10.8115 0.040345 17.594 0.0103344 17.834C-0.088272 18.7043 0.52909 19.5146 1.42083 19.6776C1.99961 19.7847 1.45513 20.0334 10.6298 15.446C17.0478 12.2392 19.0328 11.2274 19.1743 11.0988C19.4144 10.8759 19.6073 10.5072 19.6759 10.1427C19.7745 9.60255 19.573 8.97661 19.1743 8.6122C18.9342 8.38926 2.41119 0.119184 2.05963 0.0420151C1.78096 -0.0180073 1.57946 -0.0137196 1.30079 0.0548763Z"
                    fill="white"
                  />
                </svg>
              )}
            </IconButton>
          </Box>

          {/* Error Messages */}
          <Box mt={1}>
            <FormErrors
              show={!this.state.commentValid && this.state.comment.length > 0}
              formErrors={this.state.formErrors}
              fieldName="comment"
            />
            <FormErrors
              show={!this.state.fileValid && this.state.formErrors.file}
              formErrors={this.state.formErrors}
              fieldName="file"
            />
          </Box>
        </Box>
      </form>
    );
  }
}

export default Comment;
